import router from '../router';

export default {
    namespaced: true,
    state: {
        progress: false,
        navigationItems: [],
        serverErrorShown: false,
        snackBarPayload: {
            show: false,
            message: '',
            color: '',
            timeout: 0
        }
    },
    getters: {
        getNavigationItems(state, getters, rootState, rootGetters) {
            if (state.navigationItems.length) {
                return state.navigationItems.filter(item => {
                    if (rootGetters['auth/loggedIn']) {
                        return rootGetters['auth/hasPermissionTo'](item.action);
                    } else {
                        return item.public;
                    }
                });
            }
        },
        getDefaultRoutePath(state, getters) {
            return getters.getNavigationItems[0] ? getters.getNavigationItems[0].to : undefined;
        }
    },
    mutations: {
        setProgress(state, progress) {
            state.progress = progress;
        },
        setNavigationItems(state, navigationItems) {
            state.navigationItems = navigationItems;
        },
        showServerError(state) {
            state.serverErrorShown = true;
        },
        setSnackBarPayload(state, payload) {
            state.snackBarPayload = payload;
        }
    },
    actions: {
        async initNavigationItems({ commit }) {
            const navigationItems = [];
            router.options.routes.map(item => {
                if (item.meta && item.meta.showInNavigation) {
                    navigationItems.push({
                        title: item.meta.title,
                        icon: item.meta.icon,
                        to: item.path,
                        module: item.meta.module,
                        action: item.meta.action,
                        public: item.meta.public,
                        menu: item.meta.menu
                    });
                }
            });

            commit('setNavigationItems', navigationItems);
        },
        showMessage({ commit }, { message, color, timeout, messagePayload, isApi }) {
            const payload = {
                show: true,
                message,
                color: color || 'success',
                timeout: timeout || 60000,
                messagePayload,
                isApi
            };
            commit('setSnackBarPayload', payload);
        },
        closeMessage({ commit }) {
            const payload = {
                show: false,
                message: '',
                color: '',
                timeout: 1
            };
            commit('setSnackBarPayload', payload);
        }
    }
};
